import { getCompanyHubEditRoute } from '@confluence/ssr-app/entry-points/routes.ts';

import { EditPageOrBlogV2Route } from './EditPageOrBlogV2Route.tsx';
import type { RouteWithNavParamsType } from '@confluence/ssr-app/entry-points/routes.ts';

export const CompanyHubEditRoute: RouteWithNavParamsType =
	getCompanyHubEditRoute(EditPageOrBlogV2Route);
